module.exports = __webpack_public_path__ + "img/1-4.5d040234.svg";